import { UploadCloud } from "lucide-react";

import { cn } from "@/components/ui/lib/utils";

export function DropzoneOverlay({
	className,
	size = "md",
}: {
	className?: string;
	size?: "sm" | "md" | "lg";
}) {
	return (
		<div
			className={cn(
				"absolute inset-0 z-90 flex items-center justify-center bg-background/80 backdrop-blur-sm",
				className,
			)}
		>
			<div
				className={cn(
					"rounded-lg border-2 border-dashed border-primary bg-background",
					size === "sm" ? "p-6" : size === "md" ? "p-12" : "p-16",
				)}
			>
				<div className="flex flex-col items-center gap-4">
					<UploadCloud
						className={cn(
							"text-primary animate-bounce",
							size === "sm" ? "h-8 w-8" : size === "md" ? "h-12 w-12" : "h-16 w-16",
						)}
					/>
					<div className="flex flex-col gap-1 text-center">
						<p className="text-lg font-medium">拖拽文件到这里</p>
						<p className="text-sm text-muted-foreground">将文件放到这里上传</p>
					</div>
				</div>
			</div>
		</div>
	);
}
